import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
export var useSettingsCopyStore = create()(devtools(function (set) { return ({
    copiedInput: null,
    pasteableConfig: null,
    setSettingsCopy: function (inputFrom, inputConfig) {
        return set({ copiedInput: inputFrom, pasteableConfig: inputConfig });
    },
    clearSettingsCopy: function () {
        return set({ copiedInput: null, pasteableConfig: null });
    },
}); }));
